import { render, staticRenderFns } from "./CRResultsMulti.vue?vue&type=template&id=2e5fef30&scoped=true"
import script from "./CRResultsMulti.vue?vue&type=script&setup=true&lang=js"
export * from "./CRResultsMulti.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CRResultsMulti.vue?vue&type=style&index=0&id=2e5fef30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5fef30",
  null
  
)

export default component.exports